import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { EditorState, convertFromRaw } from 'draft-js';
import { convertToHTML } from 'draft-convert';
import { Button } from 'react-bootstrap';
import { CONVERT_HTML_OPTIONS } from '../constants';
import FormEditor from './FormEditor';


class BlitzEditor extends Component {

  constructor(props) {
    super(props);

    this.state = {
      showCode: false,
    };

    this.onEditorDataChange = this.onEditorDataChange.bind(this);
  }

  onEditorDataChange(event, newValue, previousValue) {
    const { change } = this.props;
    const editorState = EditorState.createWithContent(convertFromRaw(newValue));
    const contentState = editorState.getCurrentContent();
    const html = convertToHTML(CONVERT_HTML_OPTIONS)(contentState);

    change('content', html);
  }

  render() {
    const { content, toggleEditorButton, save, title, description, preview } = this.props;
    const { showCode } = this.state;
    return (
      <div className="blitz-editor">
        <div className="blitz-editor-header clearfix">
          <div className="blitz-editor-header-logo">
            <img className="fit-parent" src="/assets/img/icons/logo.png" role="presentation" />
          </div>
          <div className="blitz-editor-header-content">
            <div className="blitz-editor-header-title">{title}</div>
          </div>
          <div className="blitz-editor-header-action clearfix">
            <Button
              className="blitz-editor-header-save button-primary"
              onClick={() => {
                toggleEditorButton();
                save();
              }}
            >
              Save
            </Button>
            <Button className="blitz-editor-header-preview button-secondary" onClick={preview} >Preview</Button>
          </div>
        </div>
        <div className="blitz-editor-content">
          <Field
            name="data"
            component={FormEditor}
            onChange={this.onEditorDataChange}
          />
        </div>
        <div className="blitz-editor-output">
          <Button
            className="blitz-editor-output-toggle button-secondary"
            onClick={() => this.setState({ showCode: !showCode })}
          >Toggle Code Output</Button>
          {showCode && <div className="blitz-editor-output-dock">
            <div className="blitz-editor-output-dock-header">Code Output</div>
            <pre className="blitz-editor-output-dock-content">
              {content}
            </pre>
          </div>}
        </div>
      </div>
    );
  }
}

BlitzEditor.propTypes = {
  change: PropTypes.func,
  title: PropTypes.string,
  description: PropTypes.string,
  preview: PropTypes.func,
  content: PropTypes.string,
  toggleEditorButton: PropTypes.func,
  save: PropTypes.func,
};

const selector = formValueSelector('generic-entry');
function mapStateToProps(state) {
  return {
    entry_id: selector(state, 'id'),
    title: selector(state, 'title'),
    description: selector(state, 'description'),
    content: selector(state, 'content'),
  };
}

BlitzEditor = connect(
  mapStateToProps,
)(reduxForm({
  form: 'generic-entry',
  enableReinitialize: true,
  destroyOnUnmount: false,
})(BlitzEditor));

export default BlitzEditor;



// WEBPACK FOOTER //
// ./src/cms/form/editor/BlitzEditor.js